import { createFileRoute } from "@tanstack/react-router";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";
import { EventsCalendarMobile } from "@/components/domain/Events/EventsCalendar.mobile.tsx";

export const Route = createFileRoute("/_authenticated/mobile/schedule/")({
  component: MobileEventsScreen,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function MobileEventsScreen() {
  return (
    <>
      <EventsCalendarMobile />
    </>
  );
}
